const moment = require("moment");
require("moment/locale/tr");

const FormatDateToTR = (isoDate: string): string => {
  // Türkçe dil destek
  moment.locale("tr");

  // ürkiye saat dilimine göre ayarlandı
  return moment(isoDate).utcOffset(3).format("D MMMM YYYY");
};

export default FormatDateToTR;
